module.exports = __webpack_public_path__ + "img/empty-state.04533eb5.svg";